
const dataLogData = []

// -------------------------------------------------------------------------------------------------------------------------
export const dataLog = (msg) => {

  dataLogData.push(msg)
}

// -------------------------------------------------------------------------------------------------------------------------
export const getDataLog = () => {

  return dataLogData
}